import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from "@material-ui/core"
import React from "react"
import CloseIcon from "@material-ui/icons/Close"

export interface IViewOnlyDialog {
  open: boolean
  onClose: () => void
  maxWidth?: "sm" | "lg" | "md"
  title: string
  iconUri?: string
  dialogAction?: JSX.Element
  children: any
  fullScreen?: boolean
}

const ViewOnlyDialog: React.FunctionComponent<IViewOnlyDialog> = ({
  open,
  onClose,
  maxWidth,
  title,
  iconUri,
  dialogAction,
  children,
  fullScreen
}) => {
  return (
    <Box>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={maxWidth || "md"}
        fullWidth
        fullScreen={fullScreen}
      >
        <DialogTitle id="form-dialog-title">
          <Box display="flex" alignItems="center">
            {iconUri && <img src={iconUri} width="30px" alt="" />}
            <Box mr={1} />
            <Typography variant="h6"> {title}</Typography>
            <Box flex={2} />
            <IconButton size="small" onClick={onClose}>
              <CloseIcon fontSize="small" color="primary" />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent style={{padding: 0}} dividers>
          <Box height="1" overflow="hidden" display="flex" alignItems="stretch">
            <Box flex={5} p={3} pt={3} overflow="auto">
              {children}
            </Box>
          </Box>
        </DialogContent>
        {dialogAction && <DialogActions>{dialogAction}</DialogActions>}
      </Dialog>
    </Box>
  )
}

export default ViewOnlyDialog
